import { useOidc } from '@axa-fr/react-oidc';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useOidc();

  // If authenticated, redirect to loading page
  if (isAuthenticated) {
    return <Navigate to="/loading" replace />;
  }

  // If not authenticated, show the public page (e.g., login)
  return children;
};

export default PublicRoute;
